<kendo-grid
  #kendoGrid
  [data]="gridWrapper.gridData"
  [loading]="gridWrapper.loading"
  [height]="(bodyHeight$ | async) || 400"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  kendoGridSelectBy="id"
  [sortable]="true"
  [groupable]="true"
  [selectable]="false"
  [group]="gridWrapper.gridState.group"
  [sort]="gridWrapper.gridState.sort"
  [reorderable]="true"
  [resizable]="true"
  filterable="menu"
  (groupChange)="gridWrapper.groupChanged($event)"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
>
  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    filterClearButton="Effacer"
    filterFilterButton="Filtrer"
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper..."
  >
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
    <button
      mat-icon-button
      color="primary"
      [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
      (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </ng-template>

  <kendo-grid-column field="idCriticite" title="Criticité" [columnMenu]="false" [width]="140">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <app-colored-circle-text [bgColor]="getAlarmeColor(dataItem.idCriticite)"></app-colored-circle-text>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="localisation" title="Localisation" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="description" title="Description" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="nomSousSysteme" title="Sous-système" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="descriptionEtat" title="Etat">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="dateDeclenchement" title="Déclenchement" filterable="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>{{ dataItem.dateDeclenchement | date : 'short' }}</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="urlDetail" title="Détail" [width]="130" filterable="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <a [href]="dataItem?.urlDetail" target="_blank">
        <mat-icon color="primary">open_in_new</mat-icon>
      </a>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="Actions" [width]="220" filterable="false">
    <ng-template kendoGridCellTemplate let-dataItem>
      <button
        *ngIf="(userRole$ | async)?.quittancementAlarme && dataItem.idEtat === 1"
        mat-icon-button
        matTooltip="Demander le quittancement"
        color="primary"
        (click)="demanderQuittancement(dataItem)"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        *ngIf="(userRole$ | async)?.acquittementAlarme && dataItem.idEtat === 3"
        mat-icon-button
        matTooltip="Demander l'acquittement"
        color="primary"
        (click)="demanderAcquittement(dataItem)"
      >
        <mat-icon>send</mat-icon>
      </button>

      <button
        *ngIf="dataItem.localisation !== '-'"
        mat-icon-button
        matTooltip="Voir sur la carte"
        color="primary"
        (click)="zoomTo($event, dataItem)"
      >
        <mat-icon>zoom_in</mat-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
